define('viewModels/widgets/dataGridCells/EnabledCell',[
    'lib/knockout',
    'viewModels/ViewModel'
], function (ko, ViewModel) {
    'use strict';

    /**
     * The EnabledCellView class.
     * @class
     */
    var EnabledCellView = ViewModel.extend(function (model, enableFn) {
        var self = this;

        self.enabled = model.enabled;
        self.loading = ko.observable(false);

        var callEnableFn = function(oldEnabledValue) {
            self.loading(true);
            enableFn.call(model, model.selfUri(), !oldEnabledValue)
                .finally(function() {
                    self.loading(false);
                });
        };

        self.subscribe(self.enabled, callEnableFn, model, "beforeChange");
    });

    return EnabledCellView;
});

